import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { ValueSection } from './components/ValueSection';
import { IdentificationSection } from './components/IdentificationSection';
import { DarkPremiumSection } from './components/DarkPremiumSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { AccordionSection } from './components/AccordionSection';
import { BonusSection } from './components/BonusSection';
import { DifferenceSection } from './components/DifferenceSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { FaqSection } from './components/FaqSection';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { UpsellModal, UpsellProduct } from './components/UpsellModal';
// ====== SHOPIFY CONFIG ======
// Editable: variant IDs and cart domain.
const SHOPIFY_CART_DOMAIN = 'http://impulsodigital.vip/cart/';
const MAIN_PRODUCT_VARIANT_ID = '44791114629206';
const MAIN_PRODUCT_PRICE = 9990;
const UPSELL_PRODUCTS: UpsellProduct[] = [{
  id: 'amor-propio',
  name: 'AMOR PROPIO Y AUTOESTIMA INQUEBRANTABLE',
  variantId: '44798137401430',
  normalPrice: 13990,
  offerPrice: 3990,
  benefit: 'Fortalecé tu autoestima, aprendé a poner límites y reconectá con tu valor personal.',
  image: 'https://cdn.magicpatterns.com/uploads/aUxdvvjf2EfEm33VVYQEL4/ChatGPTImage1jun2026_11_52_51.png'
}, {
  id: 'mi-psicologa',
  name: 'Mi Psicóloga Me Dijo',
  variantId: '44739342434390',
  normalPrice: 30000,
  offerPrice: 9990,
  benefit: 'Un programa emocional para elegirte primero, sanar vínculos y trabajar tu bienestar interior.',
  image: 'https://cdn.magicpatterns.com/uploads/6geXcaXjtuGesBMC6WE5xW/ChatGPTImage18may2026_00_02_52.png'
}, {
  id: 'bienestar-natural',
  name: 'Biblioteca Premium de Bienestar Natural',
  variantId: '44798668636246',
  normalPrice: 10000,
  offerPrice: 3990,
  benefit: 'Guías naturales y prácticas para el hogar, el bienestar diario y el cuidado personal.',
  image: 'https://cdn.magicpatterns.com/uploads/72sq3RRCNFFxgLeB82qD2s/ChatGPTImage1jun2026_16_30_29.png'
}];
// Build Shopify cart permalink URL: /cart/{id}:1,{id}:1,...
const buildCheckoutUrl = (selectedVariantIds: string[]) => {
  const items = [`${MAIN_PRODUCT_VARIANT_ID}:1`, ...selectedVariantIds.map(id => `${id}:1`)];
  return `${SHOPIFY_CART_DOMAIN}${items.join(',')}`;
};
export function App() {
  const [isUpsellOpen, setIsUpsellOpen] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const handleOpenUpsell = () => {
    if (isRedirecting) return;
    setIsUpsellOpen(true);
  };
  const handleCloseUpsell = () => {
    if (isRedirecting) return;
    setIsUpsellOpen(false);
  };
  const handleConfirmUpsell = (selectedIds: string[]) => {
    if (isRedirecting) return;
    setIsRedirecting(true);
    const variantIds = UPSELL_PRODUCTS.filter(p => selectedIds.includes(p.id)).map(p => p.variantId);
    window.location.href = buildCheckoutUrl(variantIds);
  };
  return <div className="min-h-screen bg-white font-sans pb-24 md:pb-0 selection:bg-terracotta/20 selection:text-terracotta" data-id="element-0">
      <Hero onCheckout={handleOpenUpsell} data-id="element-1" />
      <ValueSection data-id="element-2" />
      <IdentificationSection onCheckout={handleOpenUpsell} data-id="element-3" />
      <DarkPremiumSection data-id="element-4" />
      <WhatYouGetSection data-id="element-5" />
      <AccordionSection data-id="element-6" />
      <BonusSection data-id="element-7" />
      <DifferenceSection data-id="element-8" />
      <SocialProofSection data-id="element-9" />
      <FinalOfferSection onCheckout={handleOpenUpsell} data-id="element-10" />
      <FaqSection data-id="element-11" />
      <Footer data-id="element-12" />

      <StickyCTA onCheckout={handleOpenUpsell} data-id="element-13" />

      <UpsellModal isOpen={isUpsellOpen} mainProductPrice={MAIN_PRODUCT_PRICE} upsellProducts={UPSELL_PRODUCTS} onConfirm={handleConfirmUpsell} onClose={handleCloseUpsell} data-id="element-14" />
    </div>;
}